import React from 'react'
import headerLogo from '../../asset/logoFC.svg'
import ham from '../../asset/hamburgerIcon.svg'
import './header.css'
import { Link } from 'react-router-dom'

export default function Header() {
  const hamScroll = () =>{
    const elm = document.getElementById("linkHam");
    elm.classList.toggle("ham", window.scrollY > 0)
  }
  window.addEventListener("scroll",hamScroll)
  return (
    <header id='header'>
        <div id='headerLogo' className="headerLogo">
            <Link to="/"><img src={headerLogo} alt="" /></Link>
        </div>
        <div id='linkHam' className="links">
            <ol className="linkList">
                <li className="linkListIteam"><Link to="/about">about</Link></li>
                <li className="linkListIteam"><Link to="/works">works</Link></li>
                <li className="linkListIteam"><Link to="/contact">contact</Link></li>
            </ol>
            <a href="#menu"><img id='hamIcon' src={ham} alt="" /></a>
        </div>
    </header>
  )
}
